<template>
  <div>
    <BaseButton success class="h-10" @click="openModal">
      <template v-if="value.length > 0"> {{ value.length }} metrics selected </template>
      <span v-else>Select metrics</span>
    </BaseButton>

    <Portal v-if="open" to="app-dialog">
      <FacebookPageInsightMetricsModal
        :period="period"
        :metrics="value"
        @apply="applyMetrics"
        @close="closeModal"
      />
    </Portal>
  </div>
</template>

<script>
import FacebookPageInsightMetricsModal from './facebook-page-insight-metrics-modal.vue';

export default {
  components: {
    FacebookPageInsightMetricsModal,
  },
  props: {
    period: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    setOpen(open) {
      this.open = open;
    },
    openModal() {
      this.setOpen(true);
    },
    closeModal() {
      this.setOpen(false);
    },
    applyMetrics(metrics) {
      this.$emit('input', metrics);
    },
  },
};
</script>
